export default __webpack_public_path__ + "static/media/reports.08fb64bd.png";